module.exports = __webpack_public_path__ + "img/TUV_R_Icons_Online_Shop_RGB.45e41960.svg";